import {creativeTemplatesApi} from 'common/src/modules/creativeTemplates/creativeTemplates.api';
import {CLStore} from 'common/src/redux/store';

export default async function getTemplateById(templateId: number, store: CLStore) {
  const {creativeTemplatesLibrary, creativeTemplatePage} = store.getState();

  return creativeTemplatePage.template?.id === templateId
    ? creativeTemplatePage.template
    : (creativeTemplatesLibrary.templates.find((t) => t.id === templateId) ??
        (
          await creativeTemplatesApi.get({
            templateId,
            includeDynamicParams: true,
            includeInstructions: true,
            includeCreativesData: true,
          })
        ).data);
}
